import React, { useEffect, useState } from "react";
import Appbar from "./appbar";
import { useHistory } from "react-router-dom";
import CustomizedTables from "./table";
import { Input, TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { Link } from "react-router-dom";
import MuiDialog from "./dialog";
import AddUser from "./addUser";

export default function Users() {
  const history = useHistory();
  
  const localStorageToken = localStorage.getItem("token");
  useEffect(() => {
    if (localStorageToken === null) history.push("/");
  }, [localStorageToken]);

  const [dialogState, setDialogState] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  function handleDialogState() {
    setDialogState(!dialogState);
  }

  const [debouncedSearch, setDebouncedSearch] = useState("");

useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(searchTerm);
  }, 1000); 

  return () => clearTimeout(timer);
}, [searchTerm]);


  return (
    <div>
      <Appbar />

   <div
  style={{
    display: "flex",
    alignItems: "center",
    margin: "3.5%",
  }}
>
  <Typography variant="h4">
    Users
  </Typography>

  <MuiDialog
    title=""
    open={dialogState}
    maxWidth="lg"
    onClose={handleDialogState}
  >
    <AddUser handleDialogState={handleDialogState} />
  </MuiDialog>

  {/* Right-side actions */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
    }}
  >
    <TextField
      variant="outlined"
      size="small"
      name="search"
      label="Search Users"
      type="text"
      value={searchTerm}
     onChange={(e) => setSearchTerm(e.target.value)}
      style={{ marginRight: 12, width: 280 }}
    />

    <Button
      variant="contained"
      color="primary"
      size="large"
      startIcon={<PersonAddIcon />}
      onClick={handleDialogState}
    >
      Add User
    </Button>
  </div>
</div>

    
      <CustomizedTables searchQuery={debouncedSearch} />
    </div>
  );
}
